import { i18n } from "../../../../i18n";

const fb = require('../../../../config/firebase.js')
import { fbFunctions } from "@/config/firebase";

const state = () => ({
    maintenanceMode: false,
    settingsLoaded: false,
    androidAppVersion: '',
    androidAppVersionMandatory: false,
    iosAppVersion: '',
    iosAppVersionMandatory: false
})

const getters = {}

const actions = {
    fetchInitialData({ commit, state }, payload) {
        fb.admininistrationCollection.doc("administration_app_settings")
            .get()
            .then(function(doc) {
                commit('setMaintenanceMode', doc.data().maintenance_mode);
                commit('setAndroidAppVersion', doc.data().android_app_version);
                commit('setAndroidAppVersionMandatory', doc.data().android_app_version_mandatory);
                commit('setIosAppVersion', doc.data().ios_app_version);
                commit('setIosAppVersionMandatory', doc.data().ios_app_version_mandatory);
                commit('setSettingsLoaded', true);
            })
            .finally(commit('setSettingsLoaded', true));
    },
    updateMaintenanceMode({ commit, state }) {
        let saveMaintenanceMode = fbFunctions.httpsCallable('apiAdmin');
        Swal.fire(
            i18n.t("administration.admin.global.modal_save_in_progress_title"),
            i18n.t("administration.admin.global.modal_save_in_progress_content"),
            "warning"
        );
        saveMaintenanceMode({
            type: 'enableOrDisableAppMaintenance',
            parameters: {
                maintenance: state.maintenanceMode
            }
        })
        .then(function(result) {
            if(result.data === "SUCCESS_UPDATED_APP_MAINTENANCE_MODE") {
                swal.fire(
                    i18n.t("administration.admin.global.modal_save_success_title"),
                    i18n.t("administration.admin.global.modal_save_success_content"),
                    "success"
                )
            }
            else {
                swal.fire(
                    i18n.t("administration.admin.global.modal_save_error_title"),
                    i18n.t("administration.admin.global.modal_save_error_content"),
                    "error"
                )
            }
        })
        .catch((e) => {
            swal.fire(
                i18n.t("administration.admin.global.modal_save_error_title"),
                i18n.t("administration.admin.global.modal_save_error_content"),
                "error"
            )
        });
    },
    updateAndroidSettings({ commit, state }) {
        let saveMaintenanceMode = fbFunctions.httpsCallable('apiAdmin');
        Swal.fire(
            i18n.t("administration.admin.global.modal_save_in_progress_title"),
            i18n.t("administration.admin.global.modal_save_in_progress_content"),
            "warning"
        );
        saveMaintenanceMode({
            type: 'updateAndroidAppSettings',
            parameters: {
                version: state.androidAppVersion,
                mandatory: state.androidAppVersionMandatory,
            }
        })
        .then(function(result) {
            if(result.data === "SUCCESS_UPDATED_APP_ANDROID_SETTINGS") {
                swal.fire(
                    i18n.t("administration.admin.global.modal_save_success_title"),
                    i18n.t("administration.admin.global.modal_save_success_content"),
                    "success"
                )
            }
            else {
                swal.fire(
                    i18n.t("administration.admin.global.modal_save_error_title"),
                    i18n.t("administration.admin.global.modal_save_error_content"),
                    "error"
                )
            }
        })
        .catch((e) => {
            swal.fire(
                i18n.t("administration.admin.global.modal_save_error_title"),
                i18n.t("administration.admin.global.modal_save_error_content"),
                "error"
            )
        });
    },
    updateIosSettings({ commit, state }) {
        let saveMaintenanceMode = fbFunctions.httpsCallable('apiAdmin');
        Swal.fire(
            i18n.t("administration.admin.global.modal_save_in_progress_title"),
            i18n.t("administration.admin.global.modal_save_in_progress_content"),
            "warning"
        );
        saveMaintenanceMode({
            type: 'updateIosAppSettings',
            parameters: {
                version: state.iosAppVersion,
                mandatory: state.iosAppVersionMandatory,
            }
        })
        .then(function(result) {
            if(result.data === "SUCCESS_UPDATED_APP_IOS_SETTINGS") {
                swal.fire(
                    i18n.t("administration.admin.global.modal_save_success_title"),
                    i18n.t("administration.admin.global.modal_save_success_content"),
                    "success"
                )
            }
            else {
                swal.fire(
                    i18n.t("administration.admin.global.modal_save_error_title"),
                    i18n.t("administration.admin.global.modal_save_error_content"),
                    "error"
                )
            }
        })
        .catch((e) => {
            swal.fire(
                i18n.t("administration.admin.global.modal_save_error_title"),
                i18n.t("administration.admin.global.modal_save_error_content"),
                "error"
            )
        });
    },
}

const mutations = {
    setSettingsLoaded(state, val) {
        state.settingsLoaded = val
    },
    setMaintenanceMode(state, val) {
        state.maintenanceMode = val;
    },
    setAndroidAppVersionMandatory(state, val) {
        state.androidAppVersionMandatory = val;
    },
    setAndroidAppVersion(state, val) {
        state.androidAppVersion = val;
    },
    setIosAppVersionMandatory(state, val) {
        state.iosAppVersionMandatory = val;
    },
    setIosAppVersion(state, val) {
        state.iosAppVersion = val;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/stores/modules/pages/admin/appSettings.js